import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { withStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';

const styles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  input: {
    display: 'flex',
    padding: '5px 5px 5px 10px',
    border: '1px solid #c3c3c3 !important',
    borderRadius: '5px',
    height: '30px',
    overflow: 'hidden',
  },
  valueContainer: {
    height: '35px',
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
    alignItems: 'center',
    padding: '5px 5px 0px 5px',
    overflow: 'hidden',
  },
  noOptionsMessage: {
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
  },
  singleValue: {
    fontSize: 17,
    color: '#88898b',
    height: '35px',
    overflow: 'hidden',
  },
  placeholder: {
    position: 'absolute',
    left: 2,
    fontSize: 17,
    color: '#88898b',
    padding: '5px 5px 5px 10px',
    height: '35px',
    overflow: 'hidden',
  },
  paper: {
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing(1),
    left: 0,
    right: 0,
    color: '#8C4799',
  },
});

function NoOptionsMessage(props) {
  return (
    <Typography id="txtNoCoincidencia" color="textSecondary" className={props.selectProps.classes.noOptionsMessage} {...props.innerProps}>
      No hay coincidencia
    </Typography>
  );
}

function inputComponent({ inputRef, ...props }) {
  return <div ref={inputRef} {...props} />;
}

function Control(props) {
  if (props.selectProps.errorText) {
    return (
      <TextField
        error
        helperText={props.selectProps.errorText}
        id="textFieldAutocompletar"
        fullWidth
        InputProps={{
          inputComponent,
          inputProps: {
            className: props.selectProps.classes.input,
            inputRef: props.innerRef,
            children: props.children,
            ...props.innerProps,
          },
        }}
        {...props.selectProps.textFieldProps}
      />
    );
  } else {
    return (
      <TextField
        id="textFieldAutocompletar"
        fullWidth
        InputProps={{
          inputComponent,
          inputProps: {
            className: props.selectProps.classes.input,
            inputRef: props.innerRef,
            children: props.children,
            ...props.innerProps,
          },
        }}
        {...props.selectProps.textFieldProps}
      />
    );
  }
}

function Option(props) {
  return (
    // <Tooltip title={props.children}>
    <MenuItem
      id="menuItemAutocompletar"
      ref={props.innerRef}
      selected={props.isFocused}
      component="div"
      style={{
        fontWeight: props.isSelected ? 500 : 400,
        background: props.isFocused ? '#e0e4e6' : 'white',
        '&:after': {
          borderBottomColor: '#523178',
        },
        '&:before': {
          borderBottomColor: '#523178',
        },
        '&:hover': {
          borderBottomColor: '#523178',
        },
      }}
      {...props.innerProps}
    >
      {props.children?.toString()?.toLowerCase()}
    </MenuItem>
    //</Tooltip>
  );
}

function Placeholder(props) {
  return (
    <Typography id="txtPlaceholder" color="textSecondary" className={props.selectProps.classes.placeholder} {...props.innerProps}>
      {props.children}
    </Typography>
  );
}

function SingleValue(props) {
  return (
    <Typography id="txtRegiones" className={props.selectProps.classes.singleValue} {...props.innerProps}>
      {props.children?.toString()?.toLowerCase()}
    </Typography>
  );
}

function ValueContainer(props) {
  return <div className={props.selectProps.classes.valueContainer}>{props.children}</div>;
}

function Menu(props) {
  return (
    <Paper square className={props.selectProps.classes.paper} {...props.innerProps}>
      {props.children}
    </Paper>
  );
}

function DropdownIndicator() {
  return (
    <div>
      <ArrowDropDown />
    </div>
  );
}
function IndicatorSeparator() {
  return <div />;
}

const components = {
  IndicatorSeparator,
  DropdownIndicator,
  Control,
  Menu,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer,
};

class AutoCompletar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: null,
    };
  }

  handleChange = (name) => (value) => {
    if (this.props.handleChange) {
      if (value !== null) {
        this.props.handleChange(this.props.nomCombo, value.value, value.label);
      } else {
        this.props.handleChange(this.props.nomCombo, 0, '');
      }
    }
  };

  findValue = (value) => {
    for (let i = 0; i < this.props.options.length; i++) {
      if (this.props.options[i].value === value) {
        return this.props.options[i];
      }
    }
    return null;
  };

  onKeyDown = (event) => {
    if (this.props.onlyAZ === true) {
      if (event.nativeEvent.key.match(/[a-zA-ZñÑ]/) === null) {
        event.preventDefault();
      }
    }
    if(event.nativeEvent.key==='Backspace'){
      if(this.props.handleChange){
        this.props.handleChange(this.props.nomCombo, 0, '');
      }
    }
  };

  render() {
    const { classes, theme } = this.props;

    const selectStyles = {
      input: (base) => ({
        ...base,
        color: theme.palette.text.primary,
        '& input': {
          font: 'inherit',
        },
      }),
      clearIndicator: () => ({
        padding: 0,
      }),
    };

    return (
      <div className={classes.root}>
        <Select
          id="comboBoxAutocompletar"
          classes={classes}
          styles={selectStyles}
          options={this.props.options}
          components={components}
          onChange={this.handleChange()}
          placeholder={this.props.placeholder}
          value={this.findValue(this.props.valor)}
          defaultOptions
          isSearchable
          isClearable={this.props.isClearable}
          errorText={this.props.errorText}
          onKeyDown={this.onKeyDown}
        />
      </div>
    );
  }
}

AutoCompletar.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(AutoCompletar);
